import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './shared/translations/vendors/en/translation.json';
import translationTR from './shared/translations/vendors/tr/translation.json';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    translation: translationEN,
  },
  tr: {
    translation: translationTR,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('cofe-admin:language'),
  fallbackLng: 'en',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
